export default __webpack_public_path__ + "static/media/case-XC60.2a0ac10d.jpg";